module.exports = "//d274d294w9cx2v.cloudfront.net/3d4cc0cbe469703769cc5823c7e32710db71b88a/images/digital-invites.jpg";